import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const NOT = () => {
  return (
    <CardSection id="NOT" title="NOT">
      <Paragraph>
        <b>TRUE</b> 또는 <b>FALSE</b> 값을 반환하는 표현식의 결과를 반대로
        바꿉니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>NOT(ARGUMENT)</Paragraph>
        <Ul>
          <Li>
            <b>ARGUMENT</b>는 반전할 논리 값입니다. <b>TRUE</b> 또는{" "}
            <b>FALSE</b>여야 합니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>NOT(`Column`)</Paragraph>
        <Img src="computeNot" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>ARGUMENT</b>는 <b>TRUE</b> 또는 <b>FALSE</b> 값, 두 값 중
          하나를 포함하는 열 또는 두 값 중 하나를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>NOT</b> 함수는 대소문자를 구분하지 않으므로 True, TRUE, true를
          동일한 방식으로 처리합니다. 마찬가지로 False, FALSE, false도 동일하게
          처리됩니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
